import { Code } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgCode = mkIcon(Code);